import { Reducer } from "redux";
import { TAction } from "loop-front";
import { TagState, Tag } from "./@types";
import { OTag } from ".";
import utilities from "../../Resources/Utils";

const RTag: Reducer<TagState, TAction> = (state = {}, action) => {
    const { POST_ITEM_SUCCESS, LIST_RECEIVED, PUT_ITEM_SUCCESS, DELETE_LIST_SUCCESS } = OTag.Actions;
    switch (action.type) {
        case DELETE_LIST_SUCCESS: return { ...state, list: state.list?.filter(x => action.additionalDispatchData?.selectedTags?.findIndex((st: Tag) => st.id === x.id) === -1) }
        case PUT_ITEM_SUCCESS: return { ...state, list: utilities.updateItemList(state.list || [], action.data, 'PUT') }
        case LIST_RECEIVED: return { ...state, list: action.data }
        case POST_ITEM_SUCCESS: return { ...state, list: utilities.updateItemList<Tag>(state.list || [], action.data, 'PUT') }
        default: return state;
    }
}

export default RTag;